<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="900px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <UpdateLevel
      ref="updateLevel"
      :orgCode="orgCode"
      :depCode="depCode"
      :type="type"
      @choose-change="(e) => (checkedRow = e)"
    />
    <span slot="footer">
      <el-button v-if="!type" size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button v-if="type" size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="checkedCount"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import UpdateLevel from './index'
export default {
  components: {
    UpdateLevel,
  },
  props: {
    visible: {type: Boolean, default: false},
    title: {type: String, default: ''},
    orgCode: {type: String, default: ''},
    depCode: {type: String, default: ''},
    type: {type: String, default: ''},
  },
  computed: {
    checkedCount() {
      return !this.checkedRow
    },
  },
  data() {
    return {
      checkedRow: null,
    }
  },
  methods: {
    confirm() {
      if (!this.checkedRow) return

      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.checkedRow = null
    },
  },
}
</script>
